import * as z from 'zod/v4';

import type { Coupon, SportkryssCoupon } from '../coupon/entry.js';
import {
  type BetSchemaType,
  externalSystemsOneXTwoBetSchema,
  oneXTwoBetSchema,
  sportkryssBetSchema,
  /*  scoreBoardBetSchema, */
} from './bet.js';

type BetsUnionType = z.ZodType<BetSchemaType>;
const schemas: [BetsUnionType, BetsUnionType, ...BetsUnionType[]] = [
  oneXTwoBetSchema,
  externalSystemsOneXTwoBetSchema,
  sportkryssBetSchema,
];

export const wagerSchema = z
  .object({
    bets: z.array(z.union(schemas)),
  })
  .transform((schema, ctx) => {
    let coupon: Coupon | undefined;
    let sportkryssCoupon: SportkryssCoupon | undefined;

    for (const bet of schema.bets) {
      switch (bet.type) {
        case 'PRIMARY_BET':
        case 'PRIMARY_MULTI_BET':
          coupon = bet.coupon;
          break;
        case 'ADDON_BET':
          sportkryssCoupon = bet.coupon;
          break;
        default:
          continue;
      }
    }

    if (!coupon) {
      ctx.addIssue({
        code: 'custom',
        message: 'No coupon found',
      });

      return z.NEVER;
    }

    const mergedCoupon = { ...coupon } satisfies Coupon;
    mergedCoupon.sportkryss = sportkryssCoupon?.sportkryss ?? mergedCoupon.sportkryss;
    mergedCoupon.sportkryssNumber = sportkryssCoupon?.sportkryssNumber ?? mergedCoupon.sportkryssNumber;

    return mergedCoupon;
  });
